import styled from 'styled-components';
import media from 'styled-media-query';
import { Link } from 'react-router-dom';

export const HeaderWrapper = styled.header`
	background-color: #FFFFFF;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);
    height: var(--header-height);
    left: 0;
	position: fixed;
	right: 0;
	top: 0;
	width: 100%;
    z-index: 9999;
`;

export const HeaderContent = styled.div`
	align-items: center;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
`;

export const Logo = styled(Link)`
	background: url('${process.env.REACT_APP_BUCKET_URL}/brand/logo-full-color.svg') no-repeat center;
	display: block;
	height: var(--header-height);
	width: 150px;
`;

export const NavToggler = styled.div`
	align-items: center;
	cursor: pointer;
	display: flex;
	height: 3rem;
	justify-content: center;
	padding-left: 5px;
	width: 3rem;

	${media.greaterThan('medium')`
		display: none;
	`}
`;

export const NavTogglerIcon = styled.div`
	background-color: #6978a0;
	border-radius: 2px;
	height: 3px;
	position: relative;
	transition: 0.25s ease;
	width: 20px;

	&:before,
	&:after {
		background-color: #6978a0;
		border-radius: 2px;
		content: '';
		height: 3px;
		right: 0;
		position: absolute;
		transform-origin: right;
		transition: 0.25s ease;
		width: 25px;
	}

	&:before { top: -8px; }
	&:after { top: 8px; }

	&.isOpen {
		background-color: transparent;

		&:before {
			transform: rotate(-46deg);
			top: -9px;
		}
		&:after {
			transform: rotate(46deg);
			top: 9px;
		}
	}
`;

export const Nav = styled.nav`
	${media.lessThan('medium')`
		background: #fff;
        max-height: 0;
        padding: 0 1.5rem;
		overflow: hidden;
		transition: 0.25s ease;
		width: 100%;

		&.isOpen {
            border-radius: 0 0 1rem 1rem;
            box-shadow: 0 16px 16px 0 rgba(0, 0, 0, 0.15);
			max-height: 300px;
			padding: 1rem 1.5rem;
            z-index: 9999;
		}
	`}
`;

export const SectionLinkList = styled.ul`
	${media.greaterThan('medium')`
		align-items: center;
        display: flex;
		gap: 0.75rem;
	`}
`;

export const SectionLinkItem = styled.li``;

export const SectionLink = styled.a`
	color: #6978a0;
	display: block;
	padding: 0.5rem 1rem;
	transition: 0.25s ease;

	&:hover {
		color: var(--main-color);
	}

	${media.greaterThan('medium')`
		border-radius: 2rem;
	`}
`;

export const SectionLinkButton = styled.a`
    background-color: var(--main-color);
    border-radius: 0.5rem;
    color: #fff;
    display: inline-block;
    font-size: 1rem;
    padding: 0.5rem 1.5rem;
    transition: 0.25s ease;
`;
